export default defineNuxtPlugin(async (nuxtApp) => {
  const { isPreview } = useCms()
  const { enablePreviewAccessibilityCheck } = useFeatureFlags()

  if (enablePreviewAccessibilityCheck && isPreview) {
    const vueAxe = await import('vue-axe')

    nuxtApp.vueApp.component('VueAxePopup', vueAxe.VueAxePopup)
    nuxtApp.vueApp.use(vueAxe.default, {
      auto: false,
    })

    // add custom styles to the axe popup
    useHead({
      style: [
        {
          textContent: `
           .va-popup-btn { 
              display: flex;
              justify-content: center;
              align-items: center;
           }
          `
        }
      ]
    })
  }
  else {
    nuxtApp.vueApp.component('VueAxePopup', h('div'))
  }
})
